import gql from 'graphql-tag';

/**
 * Mutation to remove a question item from an inspection template (building fork).
 */
export const removeItemFromTemplateMutation = gql`
  mutation RemoveItemFromTemplate($input: RemoveItemFromTemplateInput!) {
    removeItemFromTemplate(input: $input) {
      success
      newVersion
    }
  }
`;
